import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { campaignParams } from '../utils/campaignAttribution';

// Keep source tags in the current journey's URL, without introducing tracking
// cookies or browser storage. Existing account/payment parameters stay intact.
export default function CampaignAttribution() {
  const location = useLocation();
  const navigate = useNavigate();
  const campaign = useRef({});

  useLayoutEffect(() => {
    const incoming = campaignParams(location.search);
    if (Object.keys(incoming).length) {
      // A newly tagged visit replaces the previous campaign, rather than mixing them.
      campaign.current = incoming;
      return;
    }
    if (!Object.keys(campaign.current).length) return;
    const search = new URLSearchParams(location.search);
    Object.entries(campaign.current).forEach(([key, value]) => search.set(key, value));
    navigate({ pathname: location.pathname, search: `?${search}`, hash: location.hash }, {
      replace: true,
      state: location.state,
    });
  }, [location, navigate]);

  return null;
}
